<template>
  <el-container>
    <el-main style="padding:0;width:100vh">
      <div class="vm-search" style="height: 5vh;">
        <vm-search label="采购订单号">
          <el-input v-model.trim="filter.purchaseOrderNo" clearable/>
        </vm-search>
        <vm-search label="物料号">
          <el-input v-model.trim="filter.materialNo" clearable/>
        </vm-search>
        <el-button
            type="primary"
            :loading="loading"
            size="mini"
            style="height: 26px; margin-left: 10px; padding: 0 8px"
            @click="getData">
          查询
        </el-button>

        <el-button
            type="primary"
            :loading="loading"
            size="mini"
            style="height: 26px; margin-left: 10px; padding: 0 8px; float: right;"
            @click="getBuyOrderNo">
          查采购单
        </el-button>
        <vm-search label="条码" style="float: right;">
          <el-input v-model.trim="filter.serialNumber" clearable/>
        </vm-search>
      </div>
      <el-table
          height="30vh"
          :data="tableData"
          style="width: 100%"
          @row-click="rowClick">
        <el-table-column prop="purchaseOrderNo" align="center" label="采购单号" width="180"/>
        <el-table-column prop="supplierName" align="center" label="供应商" width="250"/>
        <el-table-column prop="supplierNo" align="center" label="供应商代码" width="100"/>
        <el-table-column prop="materialNo" align="center" label="物料号" width="180"/>
        <el-table-column
            prop="materialName"
            align="center"
            label="物料描述"
            width="400"
            show-overflow-tooltip/>
        <el-table-column prop="rowIndex" align="center" label="行号" width="100"/>
        <!--        <el-table-column prop="materialGroup" align="center" label="物料类别" width="100"/>-->
        <!--        <el-table-column prop="positionNo" align="center" label="仓位" width="100"/>-->
        <!--        <el-table-column prop="defaultLocationNo" align="center" label="库位" width="100"/>-->
        <!--        <el-table-column prop="extMaterialGroup" align="center" label="电子物料标识" width="100"/>-->
        <el-table-column prop="qty" align="center" label="数量"/>
        <el-table-column prop="price" align="center" label="总价"/>
        <el-table-column prop="unitPrice" align="center" label="单价"/>
        <el-table-column prop="measuringUnitName" align="center" label="单位"/>
        <el-table-column prop="deliveryDate" align="center" label="要求交期" width="140"/>
      </el-table>
      <div v-loading="treeLoading"
           style="width: 24%; float: left; height: 52vh; overflow-y: scroll; border-right: 1px #606266 solid;">
        <el-input v-model="batchNo" placeholder="查询批次号" style="width: 80%; margin-top: 20px;" clearable>
          <el-button slot="append" :loading="batchNoLoading" size="mini" @click="getTreeByBatchNo">
            搜索
          </el-button>
        </el-input>
        <el-tree
            style="margin: 30px;"
            default-expand-all
            :expand-on-click-node="false"
            :check-on-click-node="true"
            :data="treeData"
            :props="{'children': 'children', 'label': 'name'}"
            @node-click="handleNodeClick">
          <span slot-scope="{ node, data }" class="custom-tree-node">
            <span>{{node.label}}</span>
            <span v-if="data.type === 3" style="margin-left: 30px;">
              <el-button type="text" size="mini" @click="doRemove(node, data)">
                删除
              </el-button>
            </span>
          </span>
        </el-tree>
      </div>
      <div style="width: 74%; float: right; height: 52vh; margin-left: 1%;">
        <div style="line-height: 22px; font-size: 16px; margin-top: 20px; font-weight: bold;">数据信息</div>
        <div style="margin-left: 30px;">
          <el-row>
            <el-col :span="8">
              <span style="font-size: 15px; color: #333333; line-height: 25px;">采购单号： </span>
              <span style="color: #57a3f3;">{{selectedRow.purchaseOrderNo}}</span>
            </el-col>
            <el-col :span="8" style="margin-left: 30px;">
              <span style="font-size: 15px; color: #333333; line-height: 25px;">行项目号： </span>
              <span style="color: #57a3f3;">{{selectedRow.rowIndex}}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <span style="font-size: 15px; color: #333333; line-height: 25px;">物料号： </span>
              <span style="color: #57a3f3;">{{selectedRow.materialNo}}</span>
            </el-col>
            <el-col :span="8" style="margin-left: 30px;">
              <span style="font-size: 15px; color: #333333; line-height: 25px;">未清数量： </span>
              <span style="color: #57a3f3;">{{leftQuantity}}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <span style="font-size: 15px; color: #333333; line-height: 26px;">物料描述： </span>
              <span style="color: #57a3f3;">{{selectedRow.materialName}}</span>
            </el-col>
          </el-row>
        </div>
        <div style="line-height: 22px; font-size: 16px; margin-top: 5px; font-weight: bold;">数据维护</div>
        <div style="margin-left: 30px;">
          <!--          <el-row>-->
          <!--            <el-col :span="4">-->
          <!--              <span style="font-size: 15px; color: #333333; line-height: 32px;">物料类别： </span>-->
          <!--            </el-col>-->
          <!--            <el-col :span="10">-->
          <!--              <el-radio-group v-model="LabelPrintingBatch.materialType">-->
          <!--                <el-radio :label="1" border>贴片圆盘料</el-radio>-->
          <!--                <el-radio :label="0" border>非贴片圆盘料</el-radio>-->
          <!--              </el-radio-group>-->
          <!--            </el-col>-->
          <!--          </el-row>-->
          <el-row>
            <el-col :span="4">
              <span style="font-size: 15px; color: #333333; line-height: 32px;">本批总数： </span>
            </el-col>
            <el-col :span="5">
              <el-input v-model="LabelPrintingBatch.quantity" style="width: 100%;" @change="quantityChange"/>
            </el-col>
            <el-col :span="4" style="margin-left: 30px;">
              <span style="font-size: 15px; color: #333333; line-height: 32px;">送货单号： </span>
            </el-col>
            <el-col :span="5">
              <el-input v-model="LabelPrintingBatch.deliveryOrderNo" style="width: 100%;"/>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <span style="font-size: 15px; color: #333333; line-height: 32px;">最小包装标准数量： </span>
            </el-col>
            <el-col :span="5">
              <el-input v-model="LabelPrintingBatch.miniPackageQuantity" style="width: 100%;"
                        @change="miniPackageQuantityChange"/>
            </el-col>
            <el-col :span="4" style="margin-left: 30px;">
              <span style="font-size: 15px; color: #333333; line-height: 32px;">最小包装标签数量： </span>
            </el-col>
            <el-col :span="5">
              <el-input v-model="LabelPrintingBatch.miniPackageLabelQuantity" disabled style="width: 100%;"/>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <span style="font-size: 15px; color: #333333; line-height: 32px;">箱标准数量： </span>
            </el-col>
            <el-col :span="5">
              <el-input v-model="LabelPrintingBatch.boxQuantity" style="width: 100%;" @change="boxQuantityChange"/>
            </el-col>
            <el-col :span="4" style="margin-left: 30px;">
              <span style="font-size: 15px; color: #333333; line-height: 32px;">箱标签数量： </span>
            </el-col>
            <el-col :span="5">
              <el-input v-model="LabelPrintingBatch.boxLabelQuantity" disabled style="width: 100%;"/>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <span style="font-size: 15px; color: #333333; line-height: 32px;">尾箱数量： </span>
            </el-col>
            <el-col :span="5">
              <el-input v-model="LabelPrintingBatch.tailBoxQuantity" disabled style="width: 100%;"/>
            </el-col>
            <el-col :span="4" style="margin-left: 30px;">
              <span style="font-size: 15px; color: #333333; line-height: 32px;">仓位号： </span>
            </el-col>
            <el-col :span="5">
              <el-input v-model="LabelPrintingBatch.warehouseNo" disabled style="width: 100%;"/>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <span style="font-size: 15px; color: #333333; line-height: 32px;">生产日期： </span>
            </el-col>
            <el-col :span="5">
              <el-date-picker
                  v-model="LabelPrintingBatch.productionDate"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期"
                  style="width: 100%;"/>
            </el-col>
            <el-col :span="4" style="margin-left: 30px;">
              <span style="font-size: 15px; color: #333333; line-height: 32px;">失效日期： </span>
            </el-col>
            <el-col :span="5">
              <el-date-picker
                  v-model="LabelPrintingBatch.expirationDate"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期"
                  style="width: 100%;"/>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <span style="font-size: 15px; color: #333333; line-height: 32px;">皮重： </span>
            </el-col>
            <el-col :span="5">
              <el-input v-model="LabelPrintingBatch.tareQuantity" style="width: 100%;"/>
            </el-col>

            <el-col :span="4" style="margin-left: 30px;">
              <span style="font-size: 15px; color: #333333; line-height: 32px;">备注： </span>
            </el-col>
            <el-col :span="5">
              <el-input v-model="LabelPrintingBatch.note" style="width: 100%;"/>
            </el-col>
          </el-row>
          <el-row style="margin-top: 20px; margin-left: 20%;">
            <el-col :span="4">
              <el-button
                  v-if="editAuth"
                  type="primary"
                  style="float: right"
                  :loading="submitLoading"
                  @click="save">
                保存
              </el-button>
            </el-col>
            <el-col :span="4">
              <el-button
                  v-if="printAuth && LabelPrintingBatch.pkid"
                  type="success"
                  style="float: right"
                  :loading="printLoading"
                  @click="printLabel(1)">
                打印小标签
              </el-button>
            </el-col>
            <el-col :span="4">
              <el-button
                  v-if="printAuth && LabelPrintingBatch.pkid"
                  type="success"
                  style="float: right"
                  :loading="printLoading"
                  @click="printLabel1()">
                打印小标签V2
              </el-button>
            </el-col>
            <el-col :span="4">
              <el-button
                  v-if="printAuth && LabelPrintingBatch.pkid"
                  type="success"
                  style="float: right"
                  :loading="printLoading"
                  @click="printLabel(2)">
                打印箱标签
              </el-button>
            </el-col>
          </el-row>
        </div>
        <print-label-list ref="printLabel"/>
      </div>
    </el-main>
  </el-container>
</template>

<script>
  import VmSearch from "@/components/VmSearch.vue";
  import PrintLabelList from "@/views/LabelPrinting/PrintLabelList";

  export default {
    name: "LabelPrinting",
    components: {VmSearch, PrintLabelList},
    data() {
      return {
        editAuth: true,
        printAuth: true,
        loading: false,
        treeLoading: false,
        submitLoading: false,
        printLoading: false,
        batchNoLoading: false,
        filter: {
          purchaseOrderNo: "",
          materialNo: "",
          serialNumber: "",
        },
        tableData: [],
        selectedRow: {
          purchaseOrderNo: "",
          rowIndex: "",
          materialNo: "",
          materialName: "",
        },
        leftQuantity: 0,
        LabelPrintingBatch: {
          pkid: null,
          materialType: 1,
          purchaseOrderDetailId: null,
          batchNo: null,
          beforeEditQuantity: null,
          quantity: null,
          deliveryOrderNo: null,
          miniPackageQuantity: null,
          miniPackageLabelQuantity: null,
          boxQuantity: null,
          tareQuantity: 0,
          boxLabelQuantity: null,
          tailBoxQuantity: null,
          warehouseNo: null,
          productionDate: null,
          expirationDate: null,
          note: "",
        },
        treeData: [],
        batchNo: "",
      };
    },
    methods: {
      getData() {
        this.LabelPrintingBatch = this.$options.data().LabelPrintingBatch;
        this.selectedRow = this.$options.data().selectedRow;
        this.leftQuantity = this.$options.data().leftQuantity;
        this.batchNo = this.$options.data().batchNo;
        this.treeData = this.$options.data().treeData;
        this.tableData = this.$options.data().tableData;
        this.editAuth = this.$auth(383);
        this.printAuth = this.$auth(384);
        if (!this.filter.purchaseOrderNo && !this.filter.materialNo) {
          this.$message.error("请输入查询条件");
          return;
        }
        this.getList();
        // if (this.filter.purchaseOrderNo) {
        //   this.getTree();
        // }
      },
      getList() {
        this.loading = true;
        let params = {
          "purchaseOrderNo": this.filter.purchaseOrderNo == null ? "" : this.filter.purchaseOrderNo,
          "materialNo": this.filter.materialNo == null ? "" : this.filter.materialNo,
        };
        this.$http
            .get("basic", "purchaseOrderDetails/list", params)
            .then(resp => {
              this.loading = false;
              this.tableData = resp.data;
            });
      },
      getTree() {
        this.treeLoading = true;
        this.$http
            .get("basic", "labelPrintingBatches/tree/" + this.filter.purchaseOrderNo)
            .then(resp => {
              this.treeLoading = false;
              this.treeData = resp.data;
            }).catch(() => {
          this.treeLoading = false;
        });
      },
      getTreeByBatchNo() {
        if (!this.batchNo) {
          this.$message.error("查询批次号不能为空");
          return;
        }
        this.batchNoLoading = true;
        this.$http
            .get("basic", "labelPrintingBatches/treeByBatchNo/" + this.batchNo)
            .then(resp => {
              this.batchNoLoading = false;
              this.treeData = resp.data;
              if (resp.success) {
                this.getById(resp.data[0].pkid, true);
              }
            });
      },
      printLabel(type) {
        if (!this.LabelPrintingBatch.pkid) {
          this.$message.error("选择批次号再打印");
          return;
        }
        this.printLoading = true;
        this.$http
            .postForFile("basic", "labelPrintingBatches/printLabel/" + type + "/" + this.LabelPrintingBatch.pkid)
            .then((res) => {
              let blob = new Blob([res.data], {type: "application/pdf"});
              let pdfUrl = window.URL.createObjectURL(blob);
              window.open(pdfUrl);
              this.printLoading = false;
            }).catch(() => {
          this.printLoading = false;
          this.$message.error("获取打印信息失败");
        });
      },
      printLabel1() {
        if (!this.LabelPrintingBatch.pkid) {
          this.$message.error("选择批次号再打印");
          return;
        }
        this.printLoading = true;
        this.$http
            .post("basic", "labelPrintingBatches/getLabel/" + this.LabelPrintingBatch.pkid)
            .then((res) => {
              if (res.success) {
                res.data.forEach((item) => {
                  item.showCode = item.materialNo + "-" + item.serialNumber.substring(item.serialNumber.length - 12) + "-" + item.quantity;
                });
                this.$refs.printLabel.open(res.data);
              } else {
                this.$message.error(res.message);
              }
              this.printLoading = false;
            }).catch(() => {
          this.printLoading = false;
          this.$message.error("获取打印信息失败");
        });
      },
      printLabel2() {
        if (!this.LabelPrintingBatch.pkid) {
          this.$message.error("选择批次号再打印");
          return;
        }
        this.printLoading = true;
        this.$http
            .post("basic", "labelPrintingBatches/getLabelBox/" + this.LabelPrintingBatch.pkid)
            .then((res) => {
              if (res.success) {

              } else {
                this.$message.error(res.message);
              }
              console.log(res);
              this.printLoading = false;
            }).catch(() => {
          this.printLoading = false;
          this.$message.error("获取打印信息失败");
        });
      },
      rowClick(row) {
        // 清空维护对象
        this.LabelPrintingBatch = this.$options.data().LabelPrintingBatch;
        // 复制数据信息
        this.selectedRow = row;
        this.LabelPrintingBatch.purchaseOrderDetailId = row.pkid;
        this.LabelPrintingBatch.warehouseNo = row.defaultLocationNo;
        this.getLeftQuantity(row.pkid);
        this.filter.purchaseOrderNo = this.selectedRow.purchaseOrderNo;
        this.getTree();
      },
      handleNodeClick(node) {
        if (node.type == 1) { // 订单 节点
          this.LabelPrintingBatch = this.$options.data().LabelPrintingBatch;
          this.selectedRow = this.$options.data().selectedRow;
          this.leftQuantity = this.$options.data().leftQuantity;
        }
        if (node.type == 2) { // 订单行 节点
          for (let item of this.tableData) {
            if (node.pkid == item.pkid) {
              this.rowClick(item);
            }
          }
        }
        if (node.type == 3) { // 批次 节点
          this.getById(node.pkid);
        }
      },
      getById(id, getData) {
        this.$http
            .get("basic", "labelPrintingBatches/" + id)
            .then(resp => {
              this.LabelPrintingBatch = resp.data;
              this.LabelPrintingBatch.beforeEditQuantity = this.LabelPrintingBatch.quantity;
              if (resp.success) {
                this.selectedRow.purchaseOrderNo = resp.data.purchaseOrderNo;
                this.selectedRow.rowIndex = resp.data.rowIndex;
                this.selectedRow.materialNo = resp.data.materialNo;
                this.selectedRow.materialName = resp.data.materialName;
                this.leftQuantity = resp.data.leftQuantity;
                //
                if (getData) {
                  this.filter.purchaseOrderNo = this.selectedRow.purchaseOrderNo;
                  this.getList();
                }
              }
            });
      },
      getLeftQuantity(id) {
        this.$http
            .get("basic", "labelPrintingBatches/leftQuantity/" + id)
            .then(resp => {
              this.leftQuantity = resp.data.leftQuantity;
            });
      },
      getBuyOrderNo() {
        if (this.filter.serialNumber) {
          this.$http
              .get("basic", "labelPrintingBatches/getBuyOrderNoBySerialNumber/" + this.filter.serialNumber)
              .then(resp => {
                if (resp) {
                  this.filter.purchaseOrderNo = resp.data;
                } else {
                  this.$message.error("未查到记录");
                }
              });
        }
      },
      quantityChange() {
        if (this.LabelPrintingBatch.quantity == 0) {
          this.$message.error("不能等于0");
          return;
        }
        if (this.LabelPrintingBatch.pkid > 0) {
          if (this.LabelPrintingBatch.quantity > this.LabelPrintingBatch.beforeEditQuantity) {
            // 修改值 与 修改前值 的差 不能大于未清数量
            if ((this.LabelPrintingBatch.quantity - this.LabelPrintingBatch.beforeEditQuantity) > this.leftQuantity) {
              this.LabelPrintingBatch.quantity = this.LabelPrintingBatch.beforeEditQuantity;
              this.$message.error("不能大于未清数量");
              return;
            }
          }
        } else {
          if (this.LabelPrintingBatch.quantity > this.leftQuantity) {
            this.LabelPrintingBatch.quantity = 0;
            this.$message.error("不能大于未清数量");
            return;
          }
        }
        if (this.LabelPrintingBatch.quantity > 0 && this.LabelPrintingBatch.miniPackageQuantity > 0) {
          this.LabelPrintingBatch.miniPackageLabelQuantity = Math.ceil(this.LabelPrintingBatch.quantity / this.LabelPrintingBatch.miniPackageQuantity);
        }
        if (this.LabelPrintingBatch.quantity > 0 && this.LabelPrintingBatch.boxQuantity > 0) {
          this.LabelPrintingBatch.boxLabelQuantity = Math.ceil(this.LabelPrintingBatch.quantity / this.LabelPrintingBatch.boxQuantity);
          this.LabelPrintingBatch.tailBoxQuantity = (this.LabelPrintingBatch.quantity % this.LabelPrintingBatch.boxQuantity) == 0 ? this.LabelPrintingBatch.boxQuantity : (this.LabelPrintingBatch.quantity % this.LabelPrintingBatch.boxQuantity);
        }
      },
      miniPackageQuantityChange() {
        if (this.LabelPrintingBatch.miniPackageQuantity == 0) {
          this.$message.error("不能等于0");
          return;
        }
        if (this.LabelPrintingBatch.quantity > 0 && this.LabelPrintingBatch.miniPackageQuantity > 0) {
          this.LabelPrintingBatch.miniPackageLabelQuantity = Math.ceil(this.LabelPrintingBatch.quantity / this.LabelPrintingBatch.miniPackageQuantity);
        }
      },
      boxQuantityChange() {
        if (this.LabelPrintingBatch.boxQuantity == 0) {
          this.$message.error("不能等于0");
          return;
        }
        if (this.LabelPrintingBatch.quantity > 0 && this.LabelPrintingBatch.boxQuantity > 0) {
          this.LabelPrintingBatch.boxLabelQuantity = Math.ceil(this.LabelPrintingBatch.quantity / this.LabelPrintingBatch.boxQuantity);
          this.LabelPrintingBatch.tailBoxQuantity = (this.LabelPrintingBatch.quantity % this.LabelPrintingBatch.boxQuantity) == 0 ? this.LabelPrintingBatch.boxQuantity : (this.LabelPrintingBatch.quantity % this.LabelPrintingBatch.boxQuantity);
        }
      },
      save() {
        var num = parseFloat(this.LabelPrintingBatch.tareQuantity);
        if (isNaN(num)) {
          this.$message.error("请重新输入皮重.");
          return;
        }
        this.LabelPrintingBatch.tareQuantity = num;
        if (this.LabelPrintingBatch.tareQuantity < 0) {
          this.$message.error("皮重不能小于0");
          return;
        }

        if (!this.LabelPrintingBatch.purchaseOrderDetailId) {
          this.$message.error("请先选择行项目");
          return;
        }
        if (!this.LabelPrintingBatch.quantity ||
            !this.LabelPrintingBatch.miniPackageQuantity ||
            !this.LabelPrintingBatch.boxQuantity ||
            !this.LabelPrintingBatch.deliveryOrderNo ||
            !this.LabelPrintingBatch.productionDate ||
            !this.LabelPrintingBatch.expirationDate ||
            this.LabelPrintingBatch.materialType == null) {
          this.$message.error("请完善数据");
          return;
        }
        this.submitLoading = true;
        this.$http
            .save("basic", "labelPrintingBatches", this.LabelPrintingBatch)
            .then((res) => {
              if (res) {
                this.LabelPrintingBatch.pkid = res.data;
                this.LabelPrintingBatch.beforeEditQuantity = this.LabelPrintingBatch.quantity;
              }
              this.submitLoading = false;
              this.$message.success("保存成功");
              this.getTree();
            })
            .catch(() => {
              this.submitLoading = false;
            });
      },
      doRemove(node, data) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
              .get("basic", "labelPrintingBatches/deleteBatchById/" + data.pkid)
              .then(() => {
                this.getTree();
                this.$message.success("删除成功");
              });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
